import React, {useState, useEffect} from 'react';
import { useParams, Link } from 'react-router-dom'; 
import SearchBar from '../../Shared/SearchBar';
import ProfileHeaderEmployee from '../ProfileHeaderEmployee'
import DetailBoxEmployee from './DetailBoxEmployee/DetailBoxEmployee';
import DetailDeepBox from '../DetailDeepBox';
import DetailBoxLargeEmployee from './DetailBoxLargeEmployee/DetailBoxLargeEmployee';
import Experience from './Experience/Experience';
import DetailDeepBoxEmployee from './DetailDeepBoxEmployee/DetailDeepBoxEmployee';
import ProfileEmployeeHeader from './ProfileEmployeeHeader/ProfileEmployeeHeader';
import './employeeView.css'
import useFetchEmployee from '../../../hooks/employee/useFetchEmployee';
import Education from './Education/Education';
import DetailHeaderBoxEmployee from './DetailHeaderBox/DetailHeaderBoxEmployee';
import useCheckConversation from '../../../hooks/conversations/useCheckConversation';
import useCreateConversation from '../../../hooks/conversations/useCreateConversation';
import { useNavigate } from 'react-router-dom';
import Reviews from './Reviews/Reviews';
import useFetchEmployeeReviews from '../../../hooks/reviews/useFetchEmployeeReviews';

const EmployeeView = () => {
  const { id } = useParams();
  const { employeeData, loading, error } = useFetchEmployee(id);
  const { createConversation, isLoading: conversationLoading, error: conversationError } = useCreateConversation();
  const { checkConversationExistence, conversationExists, conversation } = useCheckConversation();
  const { reviews, loading: reviewsLoading } = useFetchEmployeeReviews(id);
  const navigate = useNavigate()

  if (loading) {
    return (
      <div className="employee-view__loading-container fade-in">
        <div className="employee-view__loading-spinner"></div>
        <p className="employee-view__loading-text">Cargando...</p>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!employeeData) {
    return <div>No company data available.</div>;
  }

  const handleConversationInitiation = async () => {
    if (conversationLoading) return; 

    try {
        if (!conversationExists) {
            const newConversation = await createConversation(id, null, 'talent');

            if (newConversation) {
                navigate(`/panel-empresa/inbox-empresa/${newConversation.id}/${id}`);
            }
        } else {
            navigate(`/panel-empresa/inbox-empresa/${conversationExists.id}/${id}`);
        }
    } catch (error) {
        console.error('Error handling conversation:', error);
    }
  };

  const handleLocationData = () => {
    const { region, comuna } = employeeData.information;
    if (!region) return '';
    return comuna ? `${region}, ${comuna}` : region;
  }

  return (
    <div>
      <div>
        <ProfileEmployeeHeader id={id} data={employeeData} handleConversationInitiation={handleConversationInitiation}/>
      </div>
      <div className="employee-view__container">
        <div className='employee-view__principal-container'>
          <div className="employee-view__information-employee-container">
            <DetailBoxEmployee title={'INFORMACIÓN'} data={{ 
              Nacimiento: employeeData.information.birthDate.split('T')[0], 
              Nacionalidad: employeeData.information.country, 
              Género: employeeData.information.genre, 
              EstadoCivil: employeeData.information.civilState, 
              Ubicación: handleLocationData()
            }} id={'large'}/>
            <DetailBoxEmployee title={'CONTACTOS'} data={{
              Teléfono:employeeData.contact.phoneNumber,
              Email: employeeData.contact.email
            }} />
          </div>
          <div className="employee-view__information-employee-container-secondary">
            <DetailHeaderBoxEmployee position={employeeData.role} experience={employeeData.experiences} />
            <DetailDeepBoxEmployee title={'SOBRE MI'} data={employeeData.aboutMe} />
        
            <DetailBoxLargeEmployee 
              title="HABILIDADES" 
              data = {[
                "Trabajo en equipo",
                "Responsabilidad",
                "Puntualidad y compromiso",
                "Habilidad para aprender",
                "Atención al cliente",
                "Flexibilidad y adaptabilidad",
                "Empatía",
                "Proactividad",
                "Comunicación efectiva",
                "Resolución de problemas",
                "Organización",
                "Trabajo bajo presión",
                "Idiomas",
                "Manejo de software"
              ]}
              checkedSkills={employeeData.skills} 
            />

          </div>
        </div>
        <div className="employee-view__secondary-container">
          <Experience data={employeeData.experiences}/>
          <Education data={employeeData.educations}/>
          <Reviews reviews={reviews} loading={reviewsLoading} type="employee" />
        </div>
        <div className="employee-view__apply-container">
          <h1>¿Te gustó este perfil?</h1>
          <button className="employee-view__apply-button" onClick={handleConversationInitiation}>
            Escríbele directamente
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeView;


